import unsavedLeaveGuard from './unsavedLeaveGuard'

// Common parts of the preview pages (drag-and-drop order of categories and items).
// A page provides a `hasUnsavedOrder` computed; `canSaveOrder` is false for users without the save button.
export default {
    mixins: [unsavedLeaveGuard],
    data() {
        return {
            canSaveOrder: true
        }
    },
    methods: {
        hasUnsavedChanges() {
            return this.canSaveOrder && !!this.hasUnsavedOrder
        },
        isCategoryInactive(status) {
            // the app shows only categories with status = 1
            return parseInt(status, 10) !== 1
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/previewPage.js